import * as store from 'store'
const extractRequest = {
  getVariables: 'hello'
}

export default extractRequest
